import * as React from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'

import { State } from 'store'
import { Account } from 'auth/state'
import { Container, ContainerHeading, HeadingSectionName } from 'uiComponents/settingsContainer'
import { PageTitle } from 'uiComponents/typography'
import { BaseRouteParams } from 'hocs'
import UsersFilter from 'settings/users/usersFilter'
import BaseKnowledgeLink from 'uiComponents/typography/BaseKnowledgeLink'
import { useTranslation } from 'translations'

interface UsersPageProps {
    accounts: Account[]
    isConviousAdmin: boolean
    children?: React.ReactNode
}

const UsersPageContainer: React.FC<UsersPageProps> = ({ accounts, children }) => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const activeAccount = accounts.find((x) => x.slug === accountSlug) || accounts[0]
    const showFilter = location.pathname.indexOf('user_list') > -1

    return (
        <div style={{ position: 'relative' }} id="account-settings">
            <PageTitle>{t('settings.users.pageTitle', { name: activeAccount.name })}</PageTitle>
            {showFilter && (
                <div style={{ margin: '-1em 0 1em 0' }}>
                    <UsersFilter accountSlug={accountSlug} />
                </div>
            )}
            <Container style={{ marginBottom: 0 }}>
                <ContainerHeading>
                    <HeadingSectionName
                        id="users-list-link"
                        className="active"
                        to={`/account/${accountSlug}/settings/users/user_list`}
                    >
                        {t('settings.users.usersTab')}
                    </HeadingSectionName>
                </ContainerHeading>
                {children}
            </Container>
            <BaseKnowledgeLink link="https://support.convious.com/help/adding-new-users" />
        </div>
    )
}

const mapStateToProps = (state: State) => {
    return {
        accounts: state.auth.user ? state.auth.user.accounts : [],
        isConviousAdmin: state.auth.user ? state.auth.user.isAdmin : false,
    }
}

export default connect(mapStateToProps)(UsersPageContainer)
